import axios from '@/lib/axios';
import { CustomerParams } from '../types';

const updateCustomer = (data: CustomerParams, custCode: string) => {
  return axios.patch(`/facility/flat_rates/customers/${custCode}`, data);
}

export default updateCustomer;